import React from 'react'

interface ReactivateIconProps {
  size?: number
  className?: string
}

/**
 * Trigger icon for the Reactivate dropdown — a left-facing curved-arrow
 * (Lucide's Undo2 shape). Uses `currentColor` so the host can theme it
 * via CSS (default `--space-700` on the trigger button).
 */
export const ReactivateIcon: React.FC<ReactivateIconProps> = ({ size = 16, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <path d="M9 14 4 9l5-5" />
    <path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5 5.5 5.5 0 0 1-5.5 5.5H11" />
  </svg>
)
